import {Button, Col, Form, Row} from 'react-bootstrap'
import {SignatureFormRequestContent} from '../../signatureForms/components/SignatureFormRequestContent'

export const RequestConsentTab: React.FC<{
  onPrev: () => void
  onNext: () => void
  sourceType: string
  sourceId: string
  hasEmail?: boolean
  hasPhone?: boolean
  requestSended: boolean
}> = ({onNext, onPrev, sourceId, sourceType, hasEmail, hasPhone}) => {
  return (
    <>
      <div className='request-consent-information'>
        <div className='title-section-policy-form'>
          <h6>Request Consent</h6>
        </div>
        <SignatureFormRequestContent
          onClose={onNext}
          refetch={() => ({})}
          onPrev={onPrev}
          sourceType={sourceType}
          sourceId={sourceId}
          hasEmail={hasEmail}
          hasPhone={hasPhone}
          // preAgentId={preAgentId}
        />
      </div>
    </>
  )
}
